import { Command } from 'commander';
import { clearCredentials } from '../credentials.js';
import { clearActiveOrg } from '../active-org.js';

export async function runLogout(): Promise<void> {
  clearCredentials();
  clearActiveOrg();
  process.stdout.write('✓ Signed out. Local credentials removed.\n');
}

export const logoutCommand = new Command('logout')
  .description('Sign out and clear local credentials')
  .option('--all', 'Sign out of all orgs (reserved; currently equivalent to default)')
  .action(async () => {
    await runLogout();
  });
